export default __webpack_public_path__ + "static/media/c_6.24f1951f.svg";